// Get log constants
export const GET_AUDIT_LOG = 'GET_AUDIT_LOG';
export const AUDIT_LOG_REQUEST_GET = 'AUDIT_LOG_REQUEST_GET';
export const AUDIT_LOG_RESPONSE_GET_SUCCESS = 'AUDIT_LOG_RESPONSE_GET_SUCCESS';
export const AUDIT_LOG_RESPONSE_GET_FAIL = 'AUDIT_LOG_RESPONSE_GET_FAIL';

export const DOWNLOAD_AUDIT_LOGS = 'DOWNLOAD_AUDIT_LOGS';
export const DOWNLOAD_AUDIT_LOGS_SUCCESS = 'DOWNLOAD_AUDIT_LOGS_SUCCESS';
export const DOWNLOAD_AUDIT_LOGS_FAIL = 'DOWNLOAD_AUDIT_LOGS_FAIL';

export const GET_AUDIT_LOG_DETAILS = 'GET_AUDIT_LOG_DETAILS';
export const GET_AUDIT_LOG_DETAILS_SUCCESS = 'GET_AUDIT_LOG_DETAILS_SUCCESS';
export const GET_AUDIT_LOG_DETAILS_FAIL = 'GET_AUDIT_LOG_DETAILS_FAIL';